export const SEVERITY = {
  high: { label: "Alta", cls: "bg-red-50 text-red-700 border-red-200" },
  medium: { label: "Media", cls: "bg-amber-50 text-amber-800 border-amber-200" },
  low: { label: "Bassa", cls: "bg-slate-50 text-slate-600 border-slate-200" },
};
export const VIEWPORT = { desktop: "Desktop", mobile: "Mobile", both: "Desktop e mobile" };
export const SCORE_LABELS = { composition: "Composizione", typography: "Tipografia", imagery: "Immagini", spacing: "Spaziature", mobile: "Mobile" };
export const STATUS = {
  rendering: "Screenshot in corso", rendered: "Screenshot pronti", analyzing: "Analisi AI in corso", analyzed: "Analisi pronta",
  fixing: "Correzioni in preparazione", ready: "Da approvare", applied: "Correzioni applicate", undone: "Correzioni annullate",
  error: "Non riuscita", discarded: "Archiviata",
};
export const STEPS = [
  { key: "shots", label: "Screenshot", note: "gratis" },
  { key: "analysis", label: "Analisi AI", note: "con stima" },
  { key: "fix", label: "Correzioni", note: "con stima" },
  { key: "approve", label: "Approvazione", note: "manuale" },
];
export const stepOf = (s) => ({ rendering: 0, rendered: 1, analyzing: 1, analyzed: 2, fixing: 2, ready: 3, applied: 4, undone: 4 }[s] ?? 0);

export function targetTitle(t) {
  if (t.target_kind === "component" || t.kind === "component") return `${t.target_name || t.name} · elemento condiviso (tutte le pagine)`;
  return `${t.target_name || t.name} · ${t.page_name}`;
}
